import ReactDOM from 'react-dom/client';
import React from 'react';
export const ConfigExamples =  ()=>{
    return (
        <div className="container">
            <h2>使い方</h2>
            Configはこのゲームの設定です。基本的にはあまり触らず、デバッグ時にはcheatをonにしたりlimit_timeを長くしたします。また、NPC対戦をつけたいのならAIをonにします。
        </div>
    )
}